try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap5');

    window.axios = require('axios');
    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

} catch (e) {
}

// region Material Switch
$(document).on('click', '.material-switch', function (event) {
    event.preventDefault();

    if ($(this).attr('aria-checked') === 'true') {
        $(this).attr('aria-checked', 'false');
        $(this).find('input').removeAttr('checked');
    } else {
        $(this).find('input').attr('checked', 'checked');
        $(this).attr('aria-checked', 'true');
    }
    $(this).find('input').trigger('change');
});

$(document).on('keydown', '.material-switch', function (event) {
    if (event.keyCode === 32) {
        event.preventDefault();

        if ($(this).attr('aria-checked') === 'true') {
            $(this).attr('aria-checked', 'false');
            $(this).find('input').removeAttr('checked');
        } else {
            $(this).find('input').attr('checked', 'checked');
            $(this).attr('aria-checked', 'true');
        }
        $(this).find('input').trigger('change');
        return false;
    }
    $(this).find('input').trigger('change');
});
// endregion

